"use client";

import { isServer, QueryClient, QueryClientProvider as ReactQueryProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { PropsWithChildren } from "react";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval: false,
        staleTime: Number.POSITIVE_INFINITY,
        networkMode: "always",
      },
      mutations: {
        networkMode: "always",
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  }

  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }

  return browserQueryClient;
}

export function QueryClientProvider({ children, hasDevTools = false }: PropsWithChildren<{ hasDevTools?: boolean }>) {
  const queryClient = getQueryClient();

  return (
    <ReactQueryProvider client={queryClient}>
      {children}
      {hasDevTools ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </ReactQueryProvider>
  );
}
